import {
  Box,
  Checkbox,
  CircularProgress,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import { AuthContext } from "../../../../context/AuthContext";
import { Add, CheckCircle } from "@mui/icons-material";
import AddRFLTaskDialog from "./AddRFLTaskDialog";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

let DEFAULT_ADD_TASK_DIALOG_DATA = {
  open: false,
  transaction: null,
};
const SelectEventRFLTasks = ({ orderId, scheduledRFLTasks, onUpdate }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [addTaskDialogData, setAddTaskDialogData] = useState(
    DEFAULT_ADD_TASK_DIALOG_DATA
  );

  const getRFLTransactionsByOrderId = async (orderId) => {
    try {
      setLoading(true);
      const response = await ezorder.get(
        `/cfi/manufacturing-orders/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      let manufacturingOrder = response.data.manufacturingOrder;
      setTransactions(manufacturingOrder.transactions);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  const addNewTask = async (transactionId, task) => {
    try {
      setLoading(true);
      const response = await ezorder.post(
        `/cfi/transactions/${transactionId}/tasks`,
        {
          task,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setAddTaskDialogData(DEFAULT_ADD_TASK_DIALOG_DATA);

      // Update Task List of Current Transaction
      let transactionsCopy = [...transactions];
      for (let txn of transactionsCopy) {
        if (txn.id == transactionId) {
          txn.tasks = response.data.tasks;
        }
      }
      setTransactions(transactionsCopy);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (orderId) {
      getRFLTransactionsByOrderId(orderId);
    } else {
      setTransactions([]);
    }
  }, [orderId]);

  return (
    <Box>
      {/* RFL Transactions (Phases) */}
      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "200px",
          }}
        >
          <CircularProgress size="3rem" />
        </Box>
      ) : (
        <Box>
          {transactions &&
            transactions.map((transaction) => (
              <Box key={transaction.id} sx={{}}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {transaction.status === "POSTED" ? (
                    <CheckCircle color="success" />
                  ) : (
                    <IconButton
                      color="success"
                      onClick={() => {
                        setAddTaskDialogData({
                          open: true,
                          transaction: transaction,
                        });
                      }}
                    >
                      <Add />
                    </IconButton>
                  )}
                  <Typography sx={{ flex: 1, fontWeight: "bold" }}>
                    {transaction.manufacturingGoal} pc.{" "}
                    {transaction.item.type.name}
                    {/* {transaction.manufacturingProcessName
                      ? `, ${transaction.manufacturingProcessName}`
                      : ""} */}
                  </Typography>
                </Box>
                {/* LIST THE PREVIOUS ASSIGNMENTS FOR THIS TRANSACTION (by txn id)*/}
                <TableContainer component={Box}>
                  <Table
                  // sx={{ minWidth: 650 }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Task</TableCell>
                        <TableCell align="right">Progress</TableCell>
                        <TableCell align="right">Goal</TableCell>
                        <TableCell align="right">Last Scheduled</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {transaction.tasks &&
                        transaction.tasks.map((task) => {
                          let lastScheduled = "TBD";
                          if (
                            task.calendarEvents &&
                            task.calendarEvents.length > 0
                          ) {
                            let latest = null;
                            for (let event of task.calendarEvents) {
                              latest =
                                latest > new Date(event.endDate)
                                  ? latest
                                  : new Date(event.endDate);
                            }

                            lastScheduled = `${
                              task.calendarEvents[0].assignedTo
                                ? task.calendarEvents[0].assignedTo
                                    .map((u) => u.fullName)
                                    .join(", ")
                                : ""
                            } on  ${dayjs(latest)
                              .tz(DEFAULT_TIMEZONE)
                              .format("MM/DD/YY")}`;
                          }

                          return (
                            <TableRow
                              hover
                              key={task.id}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                              onClick={() => {
                                // onSelect(order);
                              }}
                            >
                              <TableCell>
                                {transaction.status === "POSTED" ? (
                                  <CheckCircle color="success" />
                                ) : (
                                  <Checkbox
                                    // disabled={subPhase.progress >= 100}
                                    style={{
                                      magin: 0,
                                      padding: 0,
                                    }}
                                    checked={
                                      // TODO: IF this subPhase is in the calendarEvent.subPhases, then true. Else false
                                      scheduledRFLTasks &&
                                      scheduledRFLTasks.some(
                                        (scheduledRFLTask) =>
                                          scheduledRFLTask.id == task.id
                                      )
                                    }
                                    onChange={(e) => {
                                      // TODO: add to calendarEvent.subPhases
                                      if (e.target.checked) {
                                        onUpdate([...scheduledRFLTasks, task]);
                                      } else {
                                        let scheduledRFLTasksCopy = [
                                          ...scheduledRFLTasks,
                                        ];
                                        let idxToRemove =
                                          scheduledRFLTasksCopy.findIndex(
                                            (scheduledTask) =>
                                              scheduledTask.id == task.id
                                          );
                                        scheduledRFLTasksCopy.splice(
                                          idxToRemove,
                                          1
                                        );
                                        onUpdate(scheduledRFLTasksCopy);
                                      }
                                    }}
                                  />
                                )}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {task.process}
                              </TableCell>
                              <TableCell align="right">
                                {task.progress}
                              </TableCell>
                              <TableCell align="right">{task.goal}</TableCell>
                              <TableCell align="right">
                                {lastScheduled}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ))}
        </Box>
      )}
      <AddRFLTaskDialog
        dialogData={addTaskDialogData}
        handleClose={() => {
          setAddTaskDialogData(DEFAULT_ADD_TASK_DIALOG_DATA);
        }}
        handleSubmit={(transactionId, newTask) => {
          addNewTask(transactionId, newTask);
        }}
        loading={loading}
      />
    </Box>
  );
};

export default SelectEventRFLTasks;
